import { render, staticRenderFns } from "./DxpFileListOverlay.vue?vue&type=template&id=5f36f3aa"
import script from "./DxpFileListOverlay.vue?vue&type=script&lang=js"
export * from "./DxpFileListOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports